import React from "react";
import {connect} from "react-redux";
import Row from "../Row";
import spinner from "../../../images/icons/spinner.svg";


class Content extends React.Component {

    findElementById (array, id) {
        return array.find((element) => {
             if(element.id === id){
                 return element
            };
            return null;
        })
    }

    findStandardById (array, data) {
        let page;
        array.forEach((section, index) => {
            if(section.id === data.sectionId){
               section.clusters.forEach((cluster, index) => {
                    if(cluster.id === data.clusterId){
                        cluster.standards.forEach((standard, index) => {
                            if(standard.id === data.standardId){
                                page = standard;
                            }
                        })
                    }
                })
            }
        });

        return page;
    }

    render() {
        const {standards, introduction} = this.props;
        let pageContent = 'Loading '
        let pageElement;

        if(standards.length > 0){
            if(this.props.introductionId !== null){
                pageElement = this.findElementById(introduction, this.props.introductionId);
                pageContent = pageElement.description;
                return  <div className="col-md-8" dangerouslySetInnerHTML={{__html: pageContent}}></div>;
            }
            if(this.props.standardId === null){
                pageElement = this.findElementById(standards, this.props.sectionId);
                pageContent = pageElement.content;
                return  <div className="col-md-8" dangerouslySetInnerHTML={{__html: pageContent}}></div>;
            }else{
                pageElement = this.findStandardById(standards, this.props);
                return (
                  <div>
                      <div className='standard-intro'><h5>{pageElement.title}</h5>
                          <div dangerouslySetInnerHTML={{__html: pageElement.standard}} ></div>
                      </div>
                      <Row content={pageElement.rationale} title={'Rationale for the standard'} />
                      <Row content={pageElement.practise_points} title={'Good Practise Points'} />
                  </div>
                )
            }
        }
        return (
              <div className={"standard-loading"}>
                  <img src={spinner} alt={""} />
              </div>
        )

    }

}

function mapStateToProps(state) {
    return {
        standards: state.standards.section,
        introduction: state.standards.introductions,
    };
}

export default connect(mapStateToProps)(Content);



// WEBPACK FOOTER //
// ./src/components/elements/standardsOfCare/Content.js